import { render, staticRenderFns } from "./PhoneAuthControl.vue?vue&type=template&id=415e30fc&"
import script from "./PhoneAuthControl.vue?vue&type=script&lang=ts&"
export * from "./PhoneAuthControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports